import { BaseHeading } from "./BaseHeading.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/headings/Heading5.tsx
const Heading5 = ({ children, color = "gray", size = "h5", ta, "data-testid": testId }) => /* @__PURE__ */ jsx(BaseHeading, {
	order: 5,
	size,
	color,
	ta,
	"data-testid": testId,
	children
});

//#endregion
export { Heading5 };